module.exports = __webpack_public_path__ + "img/ccf-1.bc86500b.webp";